import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import Paper from '@mui/material/Paper';

import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { isNonLocalNonLoggedInVisitor } from '../utils/utils';

const toyBoxStyles = (theme) => ({
  toyBox: {
    backgroundColor: '#e7f7ff',
    padding: '4px',
    width: '100%',
    borderBottom: '1px solid #ddd',
  },
});

const ReferrerOrgPageAppBar = (props) => null;

let ToyBox = ({ classes, height, text }) => {
  return (
    <div className={classes.toyBox} style={{ height: height }}>
      {text}
    </div>
  );
};
ToyBox = withStyles(toyBoxStyles)(ToyBox);

const measureBoxStyles = (theme) => ({
  measureBox: {
    backgroundColor: '#ddd',
    height: '40px',
    borderBottom: '3px solid #333',
  },
});

let MeasureBox = ({ classes, width, text }) => {
  return (
    <div className={classes.measureBox} style={{ width: width }}>
      Measuring
    </div>
  );
};
MeasureBox = withStyles(measureBoxStyles)(MeasureBox);

const facePageStyles = (theme) => ({
  root: {
    width: '100%',
    // marginTop: theme.spacing(3),
    height: '75vh',
  },
  leftColumn: {
    width: '286px',
    backgroundColor: 'white',
    padding: 0,
    verticalAlign: 'top',
  },
  centerColumn: {
    backgroundColor: '#e7e7e7',
    padding: '0 4px 0 4px',
    verticalAlign: 'top',
  },
  rightColumn: {
    width: '280px',
    backgroundColor: 'white',
    padding: 0,
    verticalAlign: 'top',
    paddingRight: '0 !important',
  },
  columnHolder: {
    // first two were specified explicitly on element in copper
    height: '100%',
    // position: "relative",
    // margin: 0,
    minWidth: 'calc(1000px - 60px)',
    backgroundColor: '#eee',
    // boxShadow: "0 0 30px rgba(0,0,00.25)",
  },
  sideColumnStructure: {
    backgroundColor: '#fff',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0,
    overflowY: 'auto',
    position: 'relative',
    paddingBottom: '24px',
  },
  divMysteryDiv: {},
  divLeftColumn: {
    position: 'relative',
    float: 'left',
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '25%',
    height: '100%',
    minWidth: '300px',
  },
  divRightColumn: {
    position: 'relative',
    float: 'right',
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '25%',
    height: '100%',
    minWidth: '300px',
  },
  divCenterColumn: {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexFlow: 'column nowrap',
  },
  entityGroup: {
    borderTop: '1px solid #e0e0e0',
    padding: '8px 0',
    position: 'relative',
  },
  entityGroup_header: {
    cursor: 'pointer',
    padding: '12px 25px',
    position: 'relative',
  },
  entitySummary: {
    padding: '10px 25px',
  },
});

const referrerOrgPageStyles = (theme) => ({
  ...facePageStyles(theme),
});

class ReferrerOrgPage extends React.Component {
  state = {
    goToNewProspectPage: false,
  };

  render() {
    if (isNonLocalNonLoggedInVisitor()) {
      return <Redirect to="/homeDispatcher" />;
    }

    if (this.state.goToNewProspectPage) {
      return <Redirect to="newProspectPage" push />;
    }

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const { classes } = this.props;
    const summary = "How's this?";

    return (
      <Paper className={classes.root}>
        {false && <ReferrerOrgPageAppBar summary={summary} page={this} />}
        <div className={classes.columnHolder}>
          <div className={classes.divLeftColumn}>
            <div className={classes.sideColumnStructure}>
              <ToyBox height="120px" text="First Box" />
              <ToyBox height="220px" text="Second Box" />
              <MeasureBox width="280px" text="Measuring" />
            </div>
          </div>
          <div className={classes.divRightColumn}>
            <div className={classes.sideColumnStructure}>
              <div className={classes.entityGroup}>
                <div className={classes.entityGroup_header}>Tasks (20)</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
                <div className={classes.entitySummary}>Read a Book</div>
              </div>
            </div>
          </div>
          <div className={classes.divCenterColumn} />
        </div>
      </Paper>
    );
  }
}

ReferrerOrgPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});
const actionProducers = { setApiResponseInfo };
export default connect(mapStateToProps, actionProducers)(withStyles(referrerOrgPageStyles)(ReferrerOrgPage));
